export default {
	"b72605e67be5675a66a9fe055ca8ec75": "您暫未簽約先學後付訂單，請聯繫指導師瞭解詳情",
	"b835123381a57437a941eb5957bec2bf": "無效鏈接，請聯繫指導師!",
	"816d600f5c1edc267c113181dbba5065": "立即支付",
	"58f266efc455155695cd9faa0c8f6d2a": "支付中...",
	"910862f781d8bbd3adeb288fdf3a7e2b": "商品明細",
	"fc0dceaafe5baf4048d3f27a0e324bf7": "價格明細",
	"c0715b25b73053f961dc52a8e3bff6d7": "支付方式",
	"55b74ed23a133ef0dfe7af717d5ad599": "您確定要放棄支付嗎？"
}
